import { URL_FILES } from './envs'

export const STORE_STAGES = {
  INITIAL: 'initial',
  INELIGIBLE: 'ineligible',
  ACCESS_ERROR: 'access_error',
  CART: 'cart',
  DETAIL: 'detail',
  SUCCESS: 'success',
  ACTIVATION: 'activation',
}

export const STORES_STAGES_TITLE_DEFAULT = ''

export const STORES_STAGES_TITLE = {
  [STORE_STAGES.INITIAL]: 'Loja de serviços',
  [STORE_STAGES.INELIGIBLE]: 'Loja de serviços',
  [STORE_STAGES.ACCESS_ERROR]: 'Loja de serviços',
  [STORE_STAGES.CART]: 'Meu carrinho',
  [STORE_STAGES.DETAIL]: 'Detalhes do serviço',
}

export const STORE_STAGES_ALLOW_CART_ICON = [STORE_STAGES.INITIAL, STORE_STAGES.DETAIL]

export const STORE_CONFIRMATION_TERM_FILE_URL = `${URL_FILES}term/TERMO_ADESAO_SVAS.pdf`
